// export const BACKEND_BASE_URL = 'https://diabetes-app-backend.test/api/'
export const BACKEND_BASE_URL = 'https://damp-island-14527.herokuapp.com/api/'

export function backend_url (path) {
  return BACKEND_BASE_URL + path.replace(/^\//, '')
}